'use strict';
// TODO: Remove this entry from `core-js@4`
require('../proposals/accessible-object-hasownproperty');
require('../proposals/array-buffer-transfer');
require('../proposals/array-find-from-last');
require('../proposals/array-grouping-v2');
require('../proposals/change-array-by-copy-stage-4');
// require('../proposals/error-cause');
require('../proposals/global-this');
require('../proposals/promise-all-settled');
require('../proposals/promise-any');
require('../proposals/promise-with-resolvers');
require('../proposals/relative-indexing-method');
require('../proposals/set-methods-v2');
require('../proposals/string-match-all');
require('../proposals/string-replace-all-stage-4');
require('../proposals/well-formed-unicode-strings');

var path = require('../internals/path');

module.exports = path;
